import * as Oidc from 'oidc-client';

async function requireOidcClientAsync() {
    return await new Promise<typeof Oidc>((resolve, reject) => {
        (require as any).ensure([], () => {
            resolve(require('oidc-client'));
        });
    });
}

let userManager: Oidc.UserManager;
export default async function(cb: (userManager: Oidc.UserManager) => void) {
    if (userManager) {
        cb(userManager);
    } else {
        const { UserManager, WebStorageStateStore } = await requireOidcClientAsync();

        const publicRoot = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;

        /* tslint:disable */
        const hasPublisher= Array.from(document.querySelectorAll('meta')).filter((x) => x.name.indexOf('lias-document-baseurl')>=0).length>0;        
        if (hasPublisher) {
            var publisherUrl = Array.from(document.querySelectorAll('meta')).filter((x) => x.name.indexOf('lias-document-baseurl')>=0).qFirst().content;
        }
        /* tslint:enable */
        const auth = process.env.IDENTITYSERVICEURL;

        userManager = new UserManager({          
            authority: auth,
            automaticSilentRenew: true,
            client_id: 'webpub-userdate-client',
            filterProtocolClaims: true,
            loadUserInfo: true,
            monitorSession: false, 
            // @ts-ignore
            // todo on true https://stackoverflow.com/questions/61862874/identityserver4-idsrv-session-returns-changed-during-checksessioniframe-result
            popup_redirect_uri: hasPublisher ? `${publisherUrl}/login.html` : `${publicRoot}/login.html`,
            post_logout_redirect_uri: hasPublisher ? `${publisherUrl}`: `${publicRoot}/`,
            redirect_uri: hasPublisher ? `${publisherUrl}/login.html` : `${publicRoot}/login.html`,            
            response_type: 'id_token token',
            scope: 'openid profile tenant-resource roles apps-resource webpub-userdata-user',
            silent_redirect_uri: hasPublisher ? `${publisherUrl}/silent-renew.html` : `${publicRoot}/silent-renew.html`,
            stateStore: new WebStorageStateStore({
                prefix: '__noteservice_oidcclient_',
                store: window.sessionStorage,
            }),
            userStore: new WebStorageStateStore({
                prefix: '__noteservice_oidc_',
                store: window.sessionStorage,
            }),
        });
        cb(userManager);
    }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/auth/userManager.tsx